import { render } from "./BrowserPublicationDropdown.vue?vue&type=template&id=1bcf1918&scoped=true"
import script from "./BrowserPublicationDropdown.vue?vue&type=script&lang=js"
export * from "./BrowserPublicationDropdown.vue?vue&type=script&lang=js"

import "./BrowserPublicationDropdown.vue?vue&type=style&index=0&id=1bcf1918&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcf1918"]])

export default __exports__